import { useEffect, useMemo } from "react";

import {
  createFullSnippetKey,
  createSnippetKey,
} from "@/components/ContentArea/snippet-override-store";
import { useSnippetOverrideStore } from "@/components/Playground/playground-store";

const useSnippetOverrideReaction = (
  {
    prompt_name,
    version_number,
    label,
  }: { prompt_name: string; version_number?: number; label?: string },
  override?: string,
  hasChanged = false,
) => {
  const store = useSnippetOverrideStore()!;

  // Use normalized key for storage (unified overrides)
  const normalizedKey = useMemo(() => createSnippetKey(prompt_name), [prompt_name]);

  // Keep full key with version/label for metadata tracking
  const fullKey = useMemo(
    () => createFullSnippetKey(prompt_name, version_number, label),
    [prompt_name, version_number, label],
  );

  useEffect(() => {
    if (override !== undefined) {
      if (hasChanged) {
        store?.assignSnippetOverride(fullKey, override);
      } else {
        store?.removeSnippetOverride(normalizedKey);
      }
    }
  }, [override, hasChanged, normalizedKey, fullKey, store]);
};

export default useSnippetOverrideReaction;
